/* SIZESOFTX
=========================================================================================
* Descripción: Guard de rutas del panel de soporte (exige sesión válida de master)
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 17/09/2026 | Muse Spark                       | Espera validación de sesión y no confía
*              |            |                                  | solo en almacenamiento local.
* ---------------------------------------------------------------------------------------
*/

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useSupportAuth } from "../context/SupportAuthContext";

const RequireMaster = ({ children }) => {
  const { authReady, isAuthenticated } = useSupportAuth();
  const location = useLocation();

  if (!authReady) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const RequireRole = ({ rol, children }) => {
  const { authReady, hasRole } = useSupportAuth();
  if (!authReady) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!hasRole(rol)) {
    return <div style={{ padding: 24 }}>Acceso denegado: se requiere el rol {rol}.</div>;
  }
  return children;
};

export default RequireMaster;
